import React, { Component } from 'react';
import _ from 'lodash';
import Img from 'react-image';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Bounce } from 'react-activity';
import Loader from 'react-loader-spinner';
import { myLog } from '../../../../utils/Utility';

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class MessagePhysician extends Component {
    static propTypes = {
        onSendMessage: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            textMessage: '',
            chatImage: '',
            file: null,
            isOpen: false,
            loading: false,
            receiverId: '',
        };
    }

    /**
     * @inheritDoc
     */
    componentDidMount() {
        this.scrollDown();
    }
    /**
     * @inheritDoc
     */
    componentDidUpdate() {
        this.firstTimeScrollDown();
    }

    //scrollDown
    scrollDown = () => {
        this.messagesEnd.scrollIntoView({ behavior: 'auto' });
    };

    //firstTimeScrollDown
    firstTimeScrollDown = () => {
        this.messagesEnd.scrollIntoView({ behavior: 'smooth' });
    };

    /**
     *
     */
    sendMessageClicked = () => {
        const { textMessage, chatImage, receiverId } = this.state;
        if (chatImage.length !== 0) {
            this.props.onSendMessage('', chatImage, 1, receiverId);
        } else if (textMessage.length !== 0) {
            this.props.onSendMessage(textMessage, '', 0, receiverId);
        }
        myLog('textMessage,chatImage,havingImage', textMessage, chatImage);
        this.resetMessage();
    };

    /**
     *
     */
    resetMessage() {
        this.setState({
            textMessage: '',
            chatImage: '',
            receiverId: '',
        });
    }

    /**
     *
     * @param {*} files
     */
    getFiles(files) {
        this.setState({
            file: URL.createObjectURL(files[0].file),
        });
        let base64Value = '';
        base64Value = files[0].base64;
        this.setState({
            chatImage: base64Value.substring(base64Value.indexOf(',') + 1, base64Value.length),
        });
        myLog('photo', base64Value.substring(base64Value.indexOf(',') + 1, base64Value.length));
        this.sendMessageClicked();
    }

    /**
     *
     * @param {*} isChatLoading
     */
    _renderLoading(isChatLoading) {
        if (isChatLoading) {
            return (
                <div
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#FFF',
                    }}
                >
                    <p>Loading......</p>
                </div>
            );
        }
    }

    /**
     *
     * @param {*} meesage
     */
    _renderLeft(meesage) {
        if (meesage.isFile) {
            return (
                <div className="message-bubble" style={{ height: '160px' }}>
                    <div className="message-img" style={{ width: '180px' }}>
                        <Img
                            on
                            src={meesage.file}
                            loader={<Loader type="ThreeDots" color="blue" height={20} width={20} />}
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <div className="message-bubble" onFocus={() => myLog('FOCUS IS ON BIG RED DIV')}>
                    {meesage.message.split(/\n/).map((message) => (
                        <React.Fragment key={message}>
                            {message}
                            <br />
                        </React.Fragment>
                    ))}
                    {/* {meesage.message} */}
                </div>
            );
        }
    }

    /**
     *
     * @param {*} meesage
     */
    _renderRight(meesage) {
        if (meesage.isFile) {
            return (
                <div className="message-bubble you" style={{ height: '160px' }}>
                    <div className="message-img" style={{ width: '180px' }}>
                        <Img
                            on
                            src={meesage.file}
                            loader={<Loader type="ThreeDots" color="blue" height={20} width={20} />}
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <div className="message-bubble you">
                    {meesage.message.split(/\n/).map((message) => (
                        <React.Fragment key={message}>
                            {message}
                            <br />
                        </React.Fragment>
                    ))}
                    {/* {meesage.message} */}
                </div>
            );
        }
    }

    /**
     *
     * @param {*} chatList
     * @param {*} userType
     */
    _renderMessage(chatList, userType) {
        // alert(chatList.length);
        if (chatList.length === 0) {
            return (
                <div
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#FFF',
                        width: '100%',
                    }}
                >
                    <p className="align-center">Start a Message Here</p>
                </div>
            );
        } else {
            return _.map(chatList, (item) => {
                if (item.role === userType) {
                    return this._renderRight(item);
                } else {
                    return this._renderLeft(item);
                }
            });
        }
    }

    render() {
        const { isChatLoading, chatList, userType } = this.props;
        return (
            <React.Fragment>
                <div className="video-fields-area scrollbar" style={{ display: 'inline' }}>
                    <div className="meg-bar clearfix" style={{ height: '9.5%' }}>
                        <span style={{ width: '90%' }}>Chat Message</span>
                    </div>
                    <div className="message-area" style={{ width: '100%' }}>
                        {this._renderLoading(isChatLoading)}
                        <div className="bubble-area scrollbar" style={{ height: '500px' }}>
                            {this._renderMessage(chatList, userType)}
                            <div
                                style={{ float: 'left', clear: 'both', marginTop: '5px' }}
                                ref={(el) => {
                                    this.messagesEnd = el;
                                }}
                            />
                        </div>
                    </div>
                    <div className="message-field">
                        <table>
                            <tbody>
                                <tr>
                                    {/* <td>
                             <div className="mdl-button mdl-button--primary mdl-button--icon mdl-button--file">
                                 <i className="material-icons">attach_file</i>
                                 <FileBase64
                                 multiple={true}
                                 onDone={this.getFiles.bind(this)}
                                 />
                             </div>
                             </td> */}
                                    <td>
                                        <input
                                            style={{ textAlign: 'initial' }}
                                            placeholder="Type your message here..."
                                            type="text"
                                            name=""
                                            maxLength={255}
                                            value={this.state.textMessage}
                                            onChange={(evt) => {
                                                this.setState({
                                                    textMessage: evt.target.value.trimLeft(),
                                                });
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter' && !e.shiftKey)
                                                    this.sendMessageClicked();
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <button
                                            onClick={() => {
                                                this.sendMessageClicked();
                                            }}
                                            onKeyPress={() => {
                                                this.sendMessageClicked();
                                            }}
                                            className="mdl-button-send green-bg mdl-js-button mdl-button--raised mdl-js-ripple-effect"
                                            disabled={
                                                this.props.isSendMessageLoading ? 'disabled' : null
                                            }
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {this.props.isSendMessageLoading ? (
                                                    <Bounce size={15} color="#FFF" />
                                                ) : (
                                                    <i className="material-icons">send</i>
                                                )}
                                            </div>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default connect()(MessagePhysician);
